import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { TreeModel } from '@app/shared/components/tree/tree.model';
import { TreeAdapter } from '@app/shared/util/tree-adapter.utils';
import { Log } from 'ng2-logger';

@Component({
  selector: 'app-task-instructions-tree-modal',
  templateUrl: './task-instructions-tree-modal.component.html',
  styleUrls: ['./task-instructions-tree-modal.component.scss']
})
export class TaskInstructionsTreeModalComponent implements OnInit {
  _logger = Log.create(TaskInstructionsTreeModalComponent.name);


  @ViewChild(ModalComponent, {static: true}) modal: ModalComponent; _items = [];
  @Input() title: string;
  @Input() displayField: string;
  @Input() label = '';
  @Input() labelClass = {};
  @Input() rootPath: string;
  @Input() type: string;
  @Input() isLoading = false;

  taskId: number;
  selectedFile: TreeModel;
  isDataProcessing: boolean;

  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  constructor(private treeAdapter: TreeAdapter) {
  }

  ngOnInit(): void {
  }

  get items() {
    return this._items;
  }

  @Input()
  set items(items) {
    this._items = this.treeAdapter.adaptDocumentsToTree(items, this.displayField);
  }

  open(data: any, rootPath: string) {
    this.modal.open();

    this.isDataProcessing = true;

    this._items = this.treeAdapter.adaptDocumentLocationsToTree(data, 'name');
    this.rootPath = rootPath;
    this.flatten(this._items);

    this.isDataProcessing = false;
  }

  close() {
    this.isDataProcessing = false;
    this.modal.close();
  }

  updatePath() {
    if (this.selectedFile.fullPath.lastIndexOf("\\") < this.selectedFile.fullPath.lastIndexOf(".")) {
      this.processData(this.selectedFile);
    }
  }

  processData(data: TreeModel) {
    this.isDataProcessing = true;
    this.onUpdate.emit( {taskId: this.taskId, fullPath: data.fullPath, type: this.type});
    this.close();
  }

  flatten(nodeList) {
    nodeList.forEach((node) => {
      if (node.isSelected) {
          this.selectedFile = node;
          if (this.selectedFile.parent) {
            this.expandParent(this.selectedFile.parent);
          }
      }
      this.flatten(node.children || []);
    });
  }

  expandParent(node) {
    node.expanded = true;
    if (node.parent) {
      this.expandParent(node.parent);
    }
  }
}
